// extracted by mini-css-extract-plugin
export default {"row":"row__xBQpo","key":"key__P3NBA","value":"value__ASzTi"};